var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"group_item",class:{'selected': this.group.isSelected },on:{"click":_vm.action_SelectItem}},[_vm._v(" "+_vm._s(_vm.groupTitleString)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }